<template>
  <div class="search-container">
    <div class="search-sub-container">
      <div class="collectionTopLeft">
        <span class="collectionHeading">Menu</span>
      </div>
      <div class="collectionTopRight">
        <div class="searchFilters">
          <div class="searchProductsContainer">
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-search"></i>
              </span>
              <b-form-input v-model="search_key" class="form-control inputsearch" placeholder="Search"
                @input="getSearchedMenu" style="background: #f3f5f5">
              </b-form-input>
            </div>
          </div>
          <div class="itemsfilter">
            <div class="veg">
              <b-form-radio @change="foodFilter" v-model="selected_food_filter" value="veg" class="fileterveg" inline>
                Veg</b-form-radio>
            </div>
            <div class="nonveg">
              <b-form-radio @change="foodFilter" v-model="selected_food_filter" value="nonveg" class="fileternonveg"
                inline>Non-Veg</b-form-radio>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="main-menu-item-container">
      <div class="col-lg-2 col-md-2 category-list">
        <div class="menu_nav_view" id="menu_nav_view">
          <div id="d" class="visible-lg visible-md">
            <nav class="main-nav ng-scope">
              <ul class="main-nav-ul">
                <!--  <li class="li-active">
                  <a><i class="fa fa-tag"></i> Offers</a>
                </li> -->
                <li class="li-active" :id="1" @click="getSelectedMenu('all')">
                  <a>All</a>
                </li>
                <li class="li-active" :id="items.category_refid" v-for="items in allStoreCategories"
                  v-bind:key="items.category_refid" :data-label="items.category_name"
                  @click="getSelectedMenu(items.category_refid)">
                  <a>
                    {{ items.category_name }}
                  </a>
                </li>
                <!-- for mughliaaz client uncomment this Live Barbeque and Catering Services-->
                <!--  <li class="li-active">
                  <a
                    href="https://www.mughliaaz.com/live-barbeque.php"
                    target="_blank"
                    >Live Barbeque</a
                  >
                </li>
                <li class="li-active">
                  <a
                    href="https://www.mughliaaz.com/catering.php"
                    target="_blank"
                    >Catering Services</a
                  >
                </li> -->
              </ul>
            </nav>
          </div>
        </div>
      </div>

      <nav id="header-nav" class="navbar hide-lg hide-sm visible-sm visible-xs">
        <div class="container-fluid">
          <div class="navbar-header">
            <i id="sidebarTogglebtn" class="at-floating-navigation__button">
              <span>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em"
                  width="1em" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z">
                  </path>
                </svg>
              </span>
              Menu
            </i>
          </div>
        </div>
      </nav>
      <div id="sidebar-wrapper" class="hide-lg hide-sm visible-xs visible-sm">
        <!-- Sidebar Header -->
        <div class="sidebar-header">
          <div class="tilte-name">Category</div>
          <div><i class="fa fa-times sidebar-close"></i></div>
        </div>
        <div class="sidebar-menu">
          <ul>
            <li class="li-active" :id="1 + 'm'" @click="getSelectedMenu1('all')">
              <a>All</a>
            </li>
            <li class="li-active" :id="items.category_refid + 'm'" v-for="items in allStoreCategories"
              v-bind:key="items.category_refid" :data-label="items.category_name"
              @click="getSelectedMenu1(items.category_refid)">
              <a>
                {{ items.category_name }}
              </a>
            </li>

            <!-- for mughliaaz client uncomment this Live Barbeque and Catering Services-->
            <!-- <li class="li-active">
              <a
                href="https://www.mughliaaz.com/live-barbeque.php"
                target="_blank"
                >Live Barbeque</a
              >
            </li>
            <li class="li-active">
              <a href="https://www.mughliaaz.com/catering.php" target="_blank"
                >Catering Services</a
              >
            </li> -->
          </ul>
        </div>
      </div>
      <div id="content-wrapper" class="container visible-xs visible-sm"></div>
      <div class="overlay1 visible-xs visible-sm"></div>
      <!--<Cart />-->
      <div class="wapper">
        <b-alert class="store_open_close_alert" v-if="
          isOpen === false ||
          digital_order_setting.digital_order_enabled == 0 ||
          (digital_order_setting.pickup == 0 &&
            digital_order_setting.delivery == 0 &&
            digital_order_setting.dinein == 0)
        " show variant="danger">
          <span v-if="custom_message_store_offline != null">{{
              custom_message_store_offline
          }}</span>
          <span v-else>Currently disabled for ordering</span>
        </b-alert>

        <!--  <p>Length is {{ viewAllPromoCode.length }}</p> -->
        <div>
          <div v-if="viewAllPromoCode.length > 0" class="offer-main">
            <h5 class="heading_h5">OFFERS</h5>
            <div class="offer-sub" v-for="(promocode, index) in viewAllPromoCode" :key="index">
              <div class="offer row">
                <div style="display: none" class="offer-img col-xs-5">
                  <img :src="offer" />
                </div>
                <div class="offer-desc">
                  <div class="offerName">{{ promocode.coupon_code_title }}</div>
                  <div class="offerText">{{ promocode.description }}</div>

                  <div class="promocodeandbtn">
                    <div class="couponText">
                      CODE: {{ promocode.coupan_code }}
                    </div>
                    <button class="btn btn-primary offer-btn" @click="applyPromoCode(promocode.coupan_code)">
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tempitems" v-if="allMenuItems.length > 0">
          <div v-if="tempCategories.length > 0">
            <span v-for="category in tempCategories" v-bind:key="category.category_refid"
              :data-label="category.category_name">
              <span v-if="getCount(category.category_refid, allMenuItems) > 0">
                <h5 class="heading_h5" :id="category.category_refid">
                  {{ category.category_name }}
                </h5>
                <span v-for="items in allMenuItems" v-bind:key="items.item_id">
                  <div class="col-md-3 latis-left" v-if="items.category_ref_ids == category.category_refid">
                    <div class="hover-img productImageContainer" v-if="items.image" @click="
                      showModaldata(
                        items.title,
                        items.image,
                        items.description
                      )
                    ">
                      <img :src="items.image" class="img_main" alt="" />
                      <figcaption>
                        {{ items.description }}
                      </figcaption>
                    </div>
                    <div class="productDescription">
                      <div class="itemnamelenght">
                        <div class="product-food-type">
                          <img v-if="items.food_type === 2" :src="nonveg" class="magevegnonveg" />
                          <img v-else-if="
                            items.food_type === 1 || items.food_type === 4
                          " :src="vegicon" class="magevegnonveg" />
                          <img v-else-if="items.food_type === 3" :src="egg" class="magevegnonveg" />
                          <div class="bestseller" v-if="items.recommended != 0">
                            <i class="fa fa-star"></i> Bestseller
                          </div>
                          <div class="pre-time" v-if="
                            digital_order_setting.preparation_time == 1 &&
                            items.preparation_time > 0
                          ">
                            <i class="fa fa-clock-o"></i>
                            {{ items.preparation_time }} Min
                          </div>
                        </div>
                        <div class="productContent">
                          <h2 class="productName">{{ items.title }}</h2>
                        </div>
                      </div>
                      <div class="productPriceQuantity">
                        <div class="productPrice">
                          <span v-if="items.discounted_price == 0">
                            {{ currency_symbol }} {{ items.sale_price }}</span>
                          <h6 v-if="items.discounted_price > 0">
                            {{ currency_symbol }}
                            <span style="text-decoration: line-through">{{
                                items.sale_price
                            }}</span>
                            <span>{{ items.discounted_price }}</span>
                          </h6>
                        </div>
                        <div class="product-qty">
                          <div v-if="items.option_group_ref_id == ''">
                            <button v-if="
                              isOpen == false ||
                              digital_order_setting.digital_order_enabled ==
                              0 ||
                              (digital_order_setting.pickup == 0 &&
                                digital_order_setting.delivery == 0 &&
                                digital_order_setting.dinein == 0)
                            " class="menu-add-cart-button" @click="showClosedMessage">
                              ADD
                            </button>
                            <button v-else-if="items.current_stock == 0" class="menu-add-cart-button"
                              @click="showStockMessage">
                              ADD
                            </button>
                            <span v-else>
                              <button v-if="getQuantity(items.item_id) === 0" class="menu-add-cart-button"
                                @click="addToCart(items)">
                                ADD
                              </button>
                              <div class="productCountContainer" v-if="getQuantity(items.item_id) >= 1">
                                <span class="removeProductIcon" @click="
                                  deleteFromCart(
                                    items.item_id,
                                    items.title,
                                    items
                                  )
                                ">-</span>
                                <span class="productCount">{{
                                    getQuantity(items.item_id)
                                }}</span>
                                <span class="addProductIcon" @click="addToCart(items)">+</span>
                              </div>
                            </span>
                          </div>
                          <div v-if="items.option_group_ref_id != ''">
                            <button v-if="
                              isOpen == false ||
                              digital_order_setting.digital_order_enabled ==
                              0 ||
                              (digital_order_setting.pickup == 0 &&
                                digital_order_setting.delivery == 0 &&
                                digital_order_setting.dinein == 0)
                            " class="menu-add-cart-button" @click="showClosedMessage">
                              ADD
                            </button>
                            <button v-else-if="items.current_stock == 0" class="menu-add-cart-button"
                              @click="showStockMessage">
                              ADD
                            </button>
                            <button v-else class="menu-add-cart-button" @click="getOptionGroupAddon(items)">
                              ADD
                            </button>
                          </div>
                          <div class="customize" v-if="items.option_group_ref_id != ''">
                            Customizable
                          </div>
                        </div>
                      </div>
                      <div class="out_of_stock" v-if="items.current_stock == 0">
                        Out Of Stock
                      </div>
                    </div>
                  </div>
                </span>
                <div class="clearfix"></div>
              </span>
            </span>
          </div>
          <div v-if="tempCategories.length == 0">
            <span v-for="category in allStoreCategories" v-bind:key="category.category_refid"
              :data-label="category.category_name">
              <span v-if="getCount(category.category_refid, allMenuItems) > 0">
                <h5 class="heading_h5" :id="category.category_refid">
                  {{ category.category_name }}
                </h5>
                <span v-for="items in allMenuItems" v-bind:key="items.item_id">
                  <div class="col-md-3 latis-left" v-if="items.category_ref_ids == category.category_refid">
                    <div class="hover-img productImageContainer" v-if="items.image" @click="
                      showModaldata(
                        items.title,
                        items.image,
                        items.description
                      )
                    ">
                      <img :src="items.image" class="img_main lazy-img-success" alt="" />
                      <figcaption>
                        {{ items.description }}
                      </figcaption>
                    </div>
                    <div class="productDescription">
                      <div class="itemnamelenght">
                        <div class="product-food-type">
                          <img v-if="items.food_type === 2" :src="nonveg" class="magevegnonveg" />
                          <img v-else-if="
                            items.food_type === 1 || items.food_type === 4
                          " :src="vegicon" class="magevegnonveg" />
                          <img v-else-if="items.food_type === 3" :src="egg" class="magevegnonveg" />
                          <div class="bestseller" v-if="items.recommended != 0">
                            <i class="fa fa-star"></i> Bestseller
                          </div>
                          <div class="pre-time" v-if="
                            digital_order_setting.preparation_time == 1 &&
                            items.preparation_time > 0
                          ">
                            <i class="fa fa-clock-o"></i>
                            {{ items.preparation_time }} Min
                          </div>
                        </div>
                        <div class="productContent">
                          <h2 class="productName">{{ items.title }}</h2>
                        </div>
                      </div>
                      <div class="productPriceQuantity">
                        <div class="productPrice">
                          <span v-if="items.discounted_price == 0">
                            {{ currency_symbol }} {{ items.sale_price }}</span>
                          <h6 v-if="items.discounted_price > 0">
                            {{ currency_symbol }}
                            <span style="text-decoration: line-through">{{
                                items.sale_price
                            }}</span>
                            <span>{{ items.discounted_price }}</span>
                          </h6>
                        </div>
                        <div class="product-qty">
                          <div v-if="items.option_group_ref_id == ''">
                            <button v-if="
                              isOpen == false ||
                              digital_order_setting.digital_order_enabled ==
                              0 ||
                              (digital_order_setting.pickup == 0 &&
                                digital_order_setting.delivery == 0 &&
                                digital_order_setting.dinein == 0)
                            " class="menu-add-cart-button" @click="showClosedMessage">
                              ADD
                            </button>
                            <button v-else-if="items.current_stock == 0" class="menu-add-cart-button"
                              @click="showStockMessage">
                              ADD
                            </button>
                            <span v-else>
                              <button v-if="getQuantity(items.item_id) === 0" class="menu-add-cart-button"
                                @click="addToCart(items)">
                                ADD
                              </button>
                              <div class="productCountContainer" v-if="getQuantity(items.item_id) >= 1">
                                <span class="removeProductIcon" @click="
                                  deleteFromCart(
                                    items.item_id,
                                    items.title,
                                    items
                                  )
                                ">-</span>
                                <span class="productCount">{{
                                    getQuantity(items.item_id)
                                }}</span>
                                <span class="addProductIcon" @click="addToCart(items)">+</span>
                              </div>
                            </span>
                          </div>
                          <div v-if="items.option_group_ref_id != ''">
                            <button v-if="
                              isOpen == false ||
                              digital_order_setting.digital_order_enabled ==
                              0 ||
                              (digital_order_setting.pickup == 0 &&
                                digital_order_setting.delivery == 0 &&
                                digital_order_setting.dinein == 0)
                            " class="menu-add-cart-button" @click="showClosedMessage">
                              ADD
                            </button>
                            <button v-else-if="items.current_stock == 0" class="menu-add-cart-button"
                              @click="showStockMessage">
                              ADD
                            </button>
                            <button v-else class="menu-add-cart-button" @click="getOptionGroupAddon(items)">
                              ADD
                            </button>
                          </div>
                          <div class="customize" v-if="items.option_group_ref_id != ''">
                            Customizable
                          </div>
                        </div>
                      </div>
                      <div class="out_of_stock" v-if="items.current_stock == 0">
                        Out Of Stock
                      </div>
                    </div>
                  </div>
                </span>
                <div class="clearfix"></div>
              </span>
            </span>
          </div>
        </div>
        <SearchNotFound v-if="allMenuItems.length <= 0" />
      </div>
    </div>
    <div data-loading style="
        text-align: center;
        position: fixed;
        display: none;
        margin: 0px 30%;
      "></div>

    <b-modal id="modalPopover" hide-header hide-footer class="modalimagedescontent">
      <header>
        <span @click="closeDescModal" class="modalimagedesclose">&times;</span>
      </header>
      <div class="modal-body">
        <img :src="modaldataimg" alt="modal_item_desc_img" class="modal_item_desc_img" />
        <h2 class="modal_title_item">{{ modaldatatitle }}</h2>
        <p class="modal_item_desc">{{ modaldatadesc }}</p>
      </div>
    </b-modal>

    <b-modal id="modal-sm-optgroup" hide-footer hide-header no-close-on-backdrop class="modal fade centered-modal">
      <div class="modal-body">
        <header style="background-color: #343a40; color: #fff">
          <span @click="closeOptGrpModal" class="close-button topright">&times;</span>
        </header>
        <h5 style="font-size: 16px; padding-bottom: 10px">Choose options</h5>
        <div v-for="(addon, index) in opt_add_group" :key="index">
          <h5 style="font-size: 17px; font-weight: 700">
            {{ addon.title }} <span v-if="addon.is_addon == 1">(Optional)</span>
          </h5>
          <p style="font-size: 14px; opacity: 0.9">
            You can Choose up to {{ addon.max_selectable }} options
          </p>
          <br />
          <div v-if="addon.max_selectable == 1">
            <b-form-group>
              <div v-for="(option_list_sub, optindex) in addon.option_list" :key="optindex">
                <b-form-radio style="
                    font-weight: 400 !important;
                    font-size: 15px !important;
                    line-height: 1.5 !important;
                    letter-spacing: 0.00938em !important;
                    text-transform: capitalize;
                    padding: 5px;
                  " v-model="addon.option_list[option_list_sub]" :name="option_list_sub.title + '' + optindex"
                  @change="addoptGroup(option_list_sub)" :value="option_list_sub">
                  {{ option_list_sub.title }} : {{ currency_symbol }}
                  {{ option_list_sub.price }}
                </b-form-radio>
              </div>
            </b-form-group>
          </div>
          <div v-if="addon.max_selectable > 1">
            <b-form-group>
              <div v-for="(option_list_sub, optindex) in addon.option_list" :key="optindex">
                <b-form-checkbox v-model="opt_group" style="
                    font-weight: 400 !important;
                    font-size: 15px !important;
                    line-height: 1.5 !important;
                    letter-spacing: 0.00938em !important;
                    text-transform: capitalize;
                    padding: 5px;
                  " @change="addoptGroup(option_list_sub)" :value="option_list_sub">
                  {{ option_list_sub.title }} : {{ currency_symbol }}
                  {{ option_list_sub.price }}
                </b-form-checkbox>
              </div>
            </b-form-group>
          </div>
        </div>
        <b-button style="background-color: #ffbb0e; color: #fff" class="mt-3" variant="outline-danger" block
          @click="submitaddon">Submit</b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import nonveg from "../assets/uploads/non-veg.png";
import vegicon from "../assets//uploads/veg-icon.png";
import egg from "../assets/uploads/egg3.png";
import offer from "../assets/uploads/offer.jpeg";
import SearchNotFound from "./SearchNotFound";
//import LocationNotFound from "./LocationNotFound"
import Footer from "./Footer";
import Location from "./Location";
import Cart from "./Cart";
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import defaultimg from "../assets/images/default.jpeg";
export default {
  name: "Cart",
  data () {
    return {
      defaultimg,
      nonveg,
      vegicon,
      egg,
      offer,
      connectionStatus: "",
      search_key: "",
      read_more: false,
      selected_food_filter: "",
      readMore: {},
      custom_msg_when_store_offline: "",
      opt_add_group: [],
      opt_group: [],
      opt_group_main: [],
      selected_opt_add_group: [],
      activeclass: "active",
      selected_menu: "",
      modaldataimg: "",
      modaldatatitle: "",
      modaldatadesc: "",
    };
  },
  mixins: [Footer, Location, Cart],
  components: {
    SearchNotFound,
    //   LocationNotFound
  },
  computed: {
    ...mapGetters(["allMenuItems"]),
    ...mapGetters(["allStoreCategories"]),
    ...mapGetters(["additionalCharges"]),
    ...mapGetters(["cartItems"]),
    ...mapGetters(["tempCategories"]),
    ...mapGetters(["tempSearchCategories"]),
    ...mapGetters(["setOutletID"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["isOpen"]),
    ...mapGetters(["custom_message_store_offline"]),
    ...mapGetters(["currency_symbol"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["viewAllPromoCode"]),
  },
  methods: {
    ...mapActions(["getMenuItems"]),
    ...mapActions(["getAllPromoCode"]),
    liveba () {
      console.log(window.location);
    },
    showModaldata (title, image, description) {
      this.$bvModal.show("modalPopover");

      this.modaldatatitle = title;
      this.modaldataimg = image;
      this.modaldatadesc = description;
    },
    closeDescModal () {
      this.$bvModal.hide("modalPopover");
    },
    getCount (cat_id, menu_details) {
      // console.log("in get count method cat_id "+cat_id)
      // console.log("in get count method menu_details "+JSON.stringify(menu_details))
      let count = 0;
      menu_details.forEach((item) => {
        // console.log("in get count method cat_id "+cat_id)
        //console.log("in get count method item.category_ref_ids "+item.category_ref_ids)
        if (cat_id == item.category_ref_ids) {
          // console.log("Same")
          count++;
        }
      });
      return count;
    },

    closeOptGrpModal () {
      this.$bvModal.hide("modal-sm-optgroup");
    },
    showStockMessage () {
      this.$bvToast.toast("Item is out of stock", {
        variant: "danger",
        toaster: "b-toaster-bottom-left",
        solid: true,
      });
    },
    showClosedMessage () {
      if (this.custom_message_store_offline == null) {
        this.$bvToast.toast("Currently disabled for ordering", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });
      } else {
        this.$bvToast.toast(this.custom_message_store_offline, {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });
      }
    },
    foodFilter () {
      //   alert(this.selected_food_filter)
      this.$store.dispatch("getFilteredFood", {
        selected_food_filter: this.selected_food_filter,
      });
    },
    showLess (id) {
      this.$set(this.readMore, id, false);
      //alert("read_more is "+this.read_more)
      //this.read_more = false
      //alert("after read_more is "+this.read_more)
    },
    showMore (id) {
      // alert("read_more is ")
      //  this.read_more = true
      //alert("after read_more is "+this.read_more)
      this.$set(this.readMore, id, true);
    },
    getSelectedMenu (value) {
      //alert("value is "+ value);
      // this.selected_menu = value
      //alert("#"+value)
      let temp_val = localStorage.getItem("valueforactiveclass");
      //  alert(temp_val)
      $("#" + temp_val).removeClass("active");
      if (value == "all") {
        //alert('if')
        $("#" + 1).addClass("active");
        localStorage.setItem("valueforactiveclass", 1);
      } else {
        //alert('else')
        $("#" + value).addClass("active");
        localStorage.setItem("valueforactiveclass", value);
      }
      this.$store.dispatch("getSelectedMenu", {
        category_ref_ids: value,
      });
      //this.clickedMenuItem = value;
    },
    getSelectedMenu1 (value) {
      //alert("value is "+ value);
      // this.selected_menu = value
      //alert("#"+value)
      let temp_val = localStorage.getItem("valueforactiveclass");
      //  alert(temp_val)
      $("#" + temp_val).removeClass("active");
      if (value == "all") {
        //alert('if')
        $("#" + 1 + "m").addClass("active");
        localStorage.setItem("valueforactiveclass", 1 + "m");
      } else {
        //alert('else')
        $("#" + value + "m").addClass("active");
        localStorage.setItem("valueforactiveclass", value + "m");
      }
      this.$store.dispatch("getSelectedMenu", {
        category_ref_ids: value,
      });
      $(function () {
        // alert('toggle')
        $("#sidebar-wrapper").removeClass("active");
        $(".active").click(function () {
          // alert('Hi')
          $("#sidebar-wrapper").removeClass("active");
          $(".overlay1").fadeToggle();
          // alert('fsdf')
        });
      });
      //this.clickedMenuItem = value;
    },
    getSearchedMenu () {
      var searchvalue;
      if (this.search_key != "") {
        //   alert(this.search_key)
        searchvalue = this.titleCase(this.search_key);
        // console.log("In getSearchedMenu "+searchvalue)
        this.$store.dispatch("getSearchedMenu", {
          category_ref_ids: searchvalue,
        });
      } else {
        searchvalue = "all";
        this.$store.dispatch("getSearchedMenu", {
          category_ref_ids: searchvalue,
        });
      }
    },
    getQuantity (id) {
      let total = 0;
      //console.log("Cart length is "+ this.cartItems.length)
      if (this.cartItems.length != 0) {
        this.cartItems.find((cartitem) => {
          //console.log("Cart item Id is "+cartitem.item.items.item_id)
          //  console.log("Item Id is "+cartitem.item.items.item_id)
          if (cartitem.item.items.item_id === id) {
            //   console.log("ID same")
            total = cartitem.quantity;
            this.qty = cartitem.quantity;
          }
        });
      }
      return total;
    },
    titleCase (string) {
      var sentence = string.toLowerCase().split(" ");
      for (var i = 0; i < sentence.length; i++) {
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }
      // console.log("sentence "+sentence)
      // document.write(sentence.join(" "));
      return sentence.join(" ");
    },
    getOptionGroupAddon (item) {
      if (
        localStorage.getItem("deliverytype") == "null" ||
        localStorage.getItem("deliverytype") == null
      ) {
        // alert('order type ' +this.getOrderType)
        this.openModalOrderType();
        /*  this.$bvToast.toast(`Please select Order Type First`, {
                
                variant: 'danger',
                toaster: 'b-toaster-bottom-left',
                solid: true,
                autoHideDelay: 2000,
                })*/
      }
      if (
        localStorage.getItem("deliverytype") != "null" &&
        localStorage.getItem("deliverytype") != null
      ) {
        let opt_add_grp = {
          menu_id: this.setOutletID,
          item_id: item.item_id,
          option_group_ref_ids: item.option_group_ref_id,
        };
        let currentObj = this;
        currentObj.axios
          .post("optiongroups", opt_add_grp)
          .then(function (response) {
            let status = response.data.status;
            if (status == 200) {
              // alert(status)
              currentObj.opt_add_group = response.data.optionGroups;
              currentObj.$bvModal.show("modal-sm-optgroup");
              currentObj.opt_group_main = item;
              currentObj.selected_opt_add_group = [];
              currentObj.opt_group = [];
            }
          })
          .catch((error) => {
            //this.errorMessage = error.message;
            // alert("There was an error! "+ error);
            console.log(error);
          });
      }
    },
    addoptGroup (option_list) {
      if (option_list.max_selectable == 1) {
        //console.log("In main if")
        let productInSelect = this.selected_opt_add_group.find((selected) => {
          return (
            selected.option_list.option_group_id === option_list.option_group_id
          );
        });
        if (productInSelect) {
          this.selected_opt_add_group = this.selected_opt_add_group.filter(
            (selected) => {
              return selected.option_list.id === option_list.id;
            }
          );
          if (option_list.max_selectable == 1) {
            this.selected_opt_add_group.push({
              option_list,
            });
          }
        } else {
          this.selected_opt_add_group.push({
            option_list,
          });
        }
      } else {
        //console.log("In main else")
        let productInSelect = this.selected_opt_add_group.find((selected) => {
          if (
            selected.option_list.id === option_list.id &&
            option_list.max_selectable > 1
          ) {
            return selected.option_list.id === option_list.id;
          }
        });
        if (productInSelect) {
          this.selected_opt_add_group = this.selected_opt_add_group.filter(
            (selected) => {
              /*  console.log("selected.option_list id "+ selected.option_list.id)
                           console.log("option_list id "+ option_list.id)
                           console.log("max_selectable "+option_list.max_selectable)

*/
              if (selected.option_list.id != option_list.id) {
                console.log("Id same ");
                return selected.option_list.id != option_list.id;
              }
            }
          );
        } else {
          this.selected_opt_add_group.push({
            option_list,
          });
        }
      }
      //console.log("selected_opt_add_group "+JSON.stringify(this.selected_opt_add_group))
    },
    submitaddon () {
      // alert(JSON.stringify(this.opt_add_group))
      var i = 0;
      this.opt_add_group.forEach((item) => {
        // alert("is add on "+item.is_addon)
        if (item.is_addon == 0) {
          i++;
        }
      });
      //alert("i is "+i)
      let order_child_options = [];
      //alert("selected_opt_add_group "+JSON.stringify(this.selected_opt_add_group))
      var j = 0;
      this.selected_opt_add_group.forEach((item) => {
        //alert("is add on "+item.option_list.is_addon)
        if (item.option_list.is_addon == 0) {
          j++;
        }
      });
      //alert("i is "+i+" j is "+j)
      if (i != j) {
        this.$bvToast.toast("Please select atleast 1 option", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });
        return;
      }
      let add_opt_title = "";
      this.selected_opt_add_group.forEach((item, index) => {
        //  console.log(item.option_list.title)
        //let opt_add_total =
        order_child_options.push({
          option_ref_id: item.option_list.item_ref_id,
          title: item.option_list.title,
          price: item.option_list.price,
          qty: item.option_list.title,
          option_group_ref_id: item.option_list.opt_grp_ref_ids,
          option_group_name: item.option_list.title,
          tax_value: item.option_list.option_tax,
          total: item.option_list.price,
          total_with_tax: item.option_list.price + item.option_list.option_tax,
          type: item.option_list.is_addon,
          item_id: item.option_list.id,
          is_addon: item.option_list.is_addon,
          min_selectable: item.option_list.min_selectable,
          max_selectable: item.option_list.max_selectable,
        });

        //  add_opt_title =   ?  : "";
        // alert("Length "+this.selected_opt_add_group.length)
        //  alert("index "+index)
        if (index != this.selected_opt_add_group.length - 1) {
          add_opt_title = add_opt_title + " " + item.option_list.title + " AND";
        } else {
          add_opt_title = add_opt_title + " " + item.option_list.title;
        }

        //alert("add_opt_title "+ add_opt_title)
      });

      //alert("add_opt_title is ", add_opt_title);

      if (add_opt_title == "") {
        this.opt_group_main["add_opt_title"] = this.opt_group_main.title;
      } else {
        this.opt_group_main["add_opt_title"] =
          this.opt_group_main.title + "(" + add_opt_title + ")";
      }

      this.opt_group_main["order_child_options"] = order_child_options;
      //  console.log('opt group main '+JSON.stringify(this.opt_group_main))
      //   console.log("opt_group_main "+this.opt_group_main)
      this.addToCart(this.opt_group_main);
      this.$bvModal.hide("modal-sm-optgroup");
    },
  },
  created () {
    localStorage.removeItem("digital_order_setting");
    this.getMenuItems();
    localStorage.setItem(
      "digital_order_setting",
      JSON.stringify(this.digital_order_setting)
    );
    localStorage.setItem("currency_symbol", this.currency_symbol);

    let currentObj = this;
    setTimeout(function () {
      currentObj.getAllPromoCode();
    }, 500);
  },
  mounted () {
    this.$nextTick(function () {
      $(function () {
        $("#sidebarTogglebtn").click(function () {
          // alert('Hi')
          $("#sidebar-wrapper").toggleClass("active");
          $(".overlay1").fadeToggle();
        });
      });
    });
    //screen.width;
    //alert(screen.width)
    if (screen.width < 1366) {
      $("#" + 1 + "m").addClass("active");
      localStorage.setItem("valueforactiveclass", 1 + "m");
    } else {
      $("#" + 1).addClass("active");
      localStorage.setItem("valueforactiveclass", 1);
    }
  },
};
</script>
<style>
.at-floating-navigation__button {
  pointer-events: auto;
  outline: none;
  background-color: #ffbb0e;
  background-image: linear-gradient(315deg, #ffbb0e, #ffbb0e 50%);
  color: #fff;
  border: none;
  border-radius: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  font-size: 2rem;
  font-weight: 600;
  -webkit-transform-origin: center;
  transform-origin: center;
  transition: 0.2s ease;
  padding: 1.2rem 1rem;
}

#sidebar-wrapper {
  position: fixed;
  z-index: 5;
  top: 50px;
  bottom: 0px;
  width: 220px;
  left: -220px;
  background-color: #fff;
  transition: left 0.3s ease;
  overflow-y: auto;
}

#sidebar-wrapper.active {
  left: 0px;
}

.sidebar-header {
  display: none;
  justify-content: space-between;
  background: #000;
  padding: 10px;
  font-size: 20px;
}

.navbar {
  z-index: 3;
  position: fixed;
  right: 1rem;
  bottom: 4rem;
}

.navbar-header .toggle-btn {
  padding-top: 10px;
  padding-left: 20px;
  background-color: #ffbb0e;
  color: #fff;
  padding: 10px;
  font-size: 21px;
}

/*** Menu Items***/

.sidebar-menu {
  margin: 0px;
  list-style: none;
}

.sidebar-menu a {
  display: block;
  padding: 8px 10px;
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.sidebar-menu ul ul a {
  padding-left: 40px;
}

.sidebar-menu .li-active.active,
.sidebar-menu .li-active:hover {
  background-color: #ffbb0e;
  color: white;
}

.sidebar-menu ul ul {
  background-color: #ffbb0e;
}

.sidebar-menu ul {
  padding: 0px;
  margin: 0px;
  list-style: none;
}

.sidebar-menu li {
  list-style: none;
  font-size: 1.6rem;
  font-weight: 500;
  border-bottom: 1px solid #000;
}

.overlay1 {
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  z-index: 1;
}

.li-active {
  border: none;
  outline: none;
  padding: 7px 0px;
  cursor: pointer;
}

/* Style the active class (and buttons on mouse-over) */

.active,
.li-active:hover {
  background-color: #ffbb0e;
  color: white;
}
</style>
